export default s => parseFloat(s.replace(/,/, '.'));



// WEBPACK FOOTER //
// ./static/js/modules/locations-finder/helpers/formatCoordinate.js